import React, { useEffect } from "react";
import "./App.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./Page/Home";
import Join from "./Page/Join";
import Contact from "./features/Contact/Contact";
import LoginPage from "./Page/LoginPage";
import SignupPage from "./Page/SignupPage";

import CartPage from "./Page/CartPage";
import Checkout from "./Page/Checkout";
import ProductDetailPage from "./Page/ProductDetailPage";
import { useDispatch, useSelector } from "react-redux";
import {
  checkAuthAsync,
  selectLoggedInUser,
  selectUserChecked,
} from "./features/Auth/authSlice";
import { PageNotFound } from "./Page/PageNotFound";

import UserOrderPage from "./Page/UserOrdersPage";
import UserProfilePage from "./Page/UserProfilePage";
import { fetchLoggedInUserAsync } from "./features/user/userSlice";
import { fetchItemsByUserIdAsync } from "./features/cart/cartSlice";
import Protected from "./features/Auth/Component/Protected";
import Logout from "./features/Auth/Component/Logout";
import AdminHome from "./Page/AdminHome";
import ProtectedAdmin from "./features/Auth/Component/ProtectedAdmin";
import AdminProductDetailsPage from "./Page/AdminProductDetailPage copy";
import AdminProductForm from "./Page/AdminProductForm";
import AdminOrdersPage from "./Page/AdminOrdersPage";
import StripeCheckout from "./Page/StripeCheckout";
import OrderSuccessPage from "./Page/OrderSuccessPage";
import ForgotPasswordPage from "./Page/ForgotPasswordPage";
import ResetPasswordPage from "./Page/ResetPasswordPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
    
        <Home />
      
    ),
  },
  {
    path: "/admin",
    element: (
      <ProtectedAdmin>
        <AdminHome />{" "}
      </ProtectedAdmin>
    ),
  },
  {
    path: "/login",
    element: <LoginPage />,
  },

  {
    path: "/signup",
    element: <SignupPage />,
  },
  {
    path: "/cart",
    element: (
      <Protected>
        <CartPage />{" "}
      </Protected>
    ),
  },
  {
    path: "/checkout",
    element: (
      <Protected>
        <Checkout />{" "}
      </Protected>
    ),
  },

  {
    path: "/product-detail/:id",
    element: (
      <Protected>
        <ProductDetailPage />{" "}
      </Protected>
    ),
  },
  {
    path: "/admin/product-detail/:id",
    element: (
      <ProtectedAdmin>
        <AdminProductDetailsPage />{" "}
      </ProtectedAdmin>
    ),
  },
  {
    path: "/admin/product-form",
    element: (
      <ProtectedAdmin>
        <AdminProductForm></AdminProductForm>
      </ProtectedAdmin>
    ),
  },
  {
    path: "/admin/orders",
    element: (
      <ProtectedAdmin>
        <AdminOrdersPage></AdminOrdersPage>
      </ProtectedAdmin>
    ),
  },
  {
    path: "/admin/product-form/edit/:id",
    element: (
      <ProtectedAdmin>
        <AdminProductForm></AdminProductForm>
      </ProtectedAdmin>
    ),
  },
  {
    path: "/order-success/:id",
    element: <OrderSuccessPage />,
  },
  {
    path: "/stripe-checkout/",
    element: (
      <Protected>
        <StripeCheckout></StripeCheckout>
      </Protected>
    ),
  },
  {
    path: "/my-orders",
    element: <UserOrderPage />,
  },
  {
    path: "/profile",
    element: <UserProfilePage />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage></ForgotPasswordPage>,
  },
 {
    path: '/reset-password',
    element: <ResetPasswordPage></ResetPasswordPage>,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
  {
    path: "/gallery",
    element: <Contact />,
  },
  {
    path: "/planPrice/:id",
    element: <Join />
   
  },


]);

function App() {
  const dispatch = useDispatch();
  const user = useSelector(selectLoggedInUser);
  const userChecked = useSelector(selectUserChecked);
  useEffect(() => {
    dispatch(checkAuthAsync());
  }, [dispatch]);
  useEffect(() => {
    if (user) {
      dispatch(fetchItemsByUserIdAsync());
      dispatch(fetchLoggedInUserAsync());
    }
  }, [dispatch, user]);

  return (
    <>
      <div className="App">
        {userChecked && <RouterProvider router={router} />}
      </div>
    </>
  );
}

export default App;

